import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import FirstPageRoundedIcon from "@mui/icons-material/FirstPageRounded";
import LastPageRoundedIcon from "@mui/icons-material/LastPageRounded";
import {
    Button,
    Card,
    CardContent,
    Grid,
    Paper,
    styled,
    Table,
    TableBody,
    TableCell,
    tableCellClasses,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ERoles, TransactionType } from "../../config";
import useAuth from "../../hooks/useAuth";
import { getAllTransactionsByFilterThunk } from "../../redux/userManagement/userManagementThunk";
import { calculateTime } from "../../utils/calculateTime";
import TablePaginationShowPage from "../../utils/tablePagination";
import AlertMessageComponent from "../components/AlertMessageComponent";
import FetchingSpinner from "../components/FetchingSpinner";
import NoRecords from "../components/NoRecords";
import FilterTransactionModel from "./FilterTransactionModel";
import RefreshButton from "../../utils/refreshButton";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        fontSize: 16,
        backgroundColor: theme.palette.common.lightBlue,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        // fontSize: 16,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },

    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

export default function ListTransaction() {
    const state = useSelector(state => state.userManagementSlice);
    const [transactionListLoader, setTransactionListLoader] = useState(false);
    const [errorResponse, setErrorResponse] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = React.useState(10);
    const [search, setSearch] = useState({});
    const dispatch = useDispatch();
    const { user } = useAuth();
    const [reload, setReload] = useState(false);
    // const [searchParams, setSearchParams] = React.useState({});
    const [searchParams, setSearchParams] = React.useState({
        name: "",
        userRole: user?.roleName,
        fromDate: "",
        toDate: "",
    });
    const [openFilter, setOpenFilter] = useState(false);
    const handleChangePage = (event, newPage) => {
        setCurrentPage(newPage);
    };
    const [operationStatus, setOperationStatus] = useState({
        success: false,
        failed: false,
        message: "",
    });

    const handleChangeRowsPerPage = event => {
        setPageSize(parseInt(event.target.value));
        setCurrentPage(0);
    };

    const handleChange = e => {
        const value = e.target.value;
        const name = e.target.name;
        setSearch({ ...search, [name]: value });
        handleStartDate();
    };

    const handleStartDate = () => {
        setTransactionListLoader(true);
        dispatch(
            getAllTransactionsByFilterThunk({
                currentPage: currentPage + 1,
                pageSize,
                roleName: user?.roleName,
                registryId: user?.registryId,
                orgId: user?.orgId,
                search,
                searchParams,
            }),
        );
        setTransactionListLoader(false);
    };

    const reloadList = () => {
        setReload(!reload);
    };

    const onClickFilter = () => {
        setOpenFilter(true);
    };

    const handleCloseFilterModel = () => {
        setOpenFilter(false);
    };

    const handleClose = () => {
        setOpenFilter(false);
    };

    const handleClickSearch = async searchParams => {
        setCurrentPage(0);
        setSearchParams(searchParams);
        handleClose();
        dispatch(
            getAllTransactionsByFilterThunk({
                currentPage: 1,
                pageSize,
                roleName: user.roleName,
                registryId: user.registryId,
                orgId: user.orgId,
                searchParams,
            }),
        );
    };

    useEffect(() => {
        dispatch(
            getAllTransactionsByFilterThunk({
                currentPage: currentPage + 1,
                pageSize,
                roleName: user?.roleName,
                registryId: user?.registryId,
                orgId: user?.orgId,
                search,
                searchParams,
            }),
        );
    }, [currentPage, pageSize, searchParams.userRole, reload]);

    return (
        <div>
            <Grid container mb={4} className="listHeader">
                <Grid item md={4} className="align-items-center">
                    <Typography variant="h3">
                        <b>Transactions</b>
                    </Typography>
                </Grid>

                <Grid item md={8} display={"flex"} justifyContent={"flex-end"}>
                    <Grid display={"flex"}>
                        <RefreshButton loading={state.controls.isGetAllTransactionsLoading} onClick={reloadList} />
                        <Button sx={{ marginRight: "10px", height: "auto" , marginLeft: "10px"}} variant="contained" onClick={onClickFilter}>
                            Filter
                        </Button>
                    </Grid>
                </Grid>
            </Grid>

            <Card className="border border-secondary-50">
                <CardContent sx={{ padding: 0 }}>
                    {state.controls.isGetAllTransactionsLoading ? (
                        <FetchingSpinner />
                    ) : state.transactionsByPageSize && state.transactionsByPageSize.length > 0 ? (
                        <TableContainer component={Paper} className="table-container" sx={{ maxHeight: "70vh" }}>
                            <Table stickyHeader aria-label="simple table">
                                <TableHead className="p-3 mb-2 row">
                                    <TableRow>
                                        <StyledTableCell className="tableHeaderFont" align="left" sx={{ width: "100px", maxWidth: "100px" }}>
                                            Sr No
                                        </StyledTableCell>
                                        {user && user.roleName === ERoles.SUPER_ADMIN && (
                                            <StyledTableCell className="tableHeaderFont" align="left" sx={{ width: "200px", maxWidth: "200px" }}>
                                                Name
                                            </StyledTableCell>
                                        )}
                                        <StyledTableCell className="tableHeaderFont" align="left" sx={{ width: "200px", maxWidth: "200px" }}>
                                            Date and Time (IST)
                                        </StyledTableCell>
                                        <StyledTableCell className="tableHeaderFont" align="left">
                                            Description
                                        </StyledTableCell>
                                        <StyledTableCell className="tableHeaderFont" align="left" sx={{ width: "200px", maxWidth: "200px" }}>
                                            Credit
                                        </StyledTableCell>
                                        <StyledTableCell className="tableHeaderFont" align="left" sx={{ width: "200px", maxWidth: "200px" }}>
                                            Debit
                                        </StyledTableCell>
                                        <StyledTableCell className="tableHeaderFont" align="left" sx={{ width: "200px", maxWidth: "200px" }}>
                                            Balance
                                        </StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {state.transactionsByPageSize.length > 0 &&
                                        state.transactionsByPageSize?.map((transaction, index) => (
                                            <>
                                                <StyledTableRow key={index}>
                                                    <StyledTableCell className="tableContentFont" align="center">
                                                        {currentPage * pageSize + index + 1}
                                                    </StyledTableCell>
                                                    {user && user.roleName === ERoles.SUPER_ADMIN && (
                                                        <StyledTableCell className="tableContentFont" align="left">
                                                            {transaction.roleName === ERoles.RESELLER_ADMIN
                                                                ? transaction.resellerName
                                                                : transaction.orgName}
                                                        </StyledTableCell>
                                                    )}

                                                    <StyledTableCell className="tableContentFont" align="left">
                                                        {/* <b>{currentPage * pageSize + index + 1}</b><br /> */}
                                                        <b>{transaction?.createdAt && calculateTime(transaction.createdAt)}</b>
                                                    </StyledTableCell>
                                                    <StyledTableCell className="tableContentFont" align="left">
                                                        {/* <b>{currentPage * pageSize + index + 1}</b><br /> */}
                                                        <Tooltip
                                                            title={<p style={{ fontSize: ".7rem" }}>{transaction?.description} </p>}
                                                            className="cursor-pointer"
                                                        >
                                                            {transaction?.description
                                                                ? transaction?.description.length > 30
                                                                    ? `${transaction?.description.substr(0, 30)}...`
                                                                    : transaction?.description
                                                                : "-"}
                                                        </Tooltip>
                                                    </StyledTableCell>
                                                    <StyledTableCell className="tableContentFont" align="left">
                                                        {transaction.transactionType === TransactionType.CREDIT && (
                                                            <Typography color="green"> {transaction?.amount?.toFixed(2)}</Typography>
                                                        )}
                                                    </StyledTableCell>
                                                    <StyledTableCell className="tableContentFont" align="left">
                                                        {transaction.transactionType === TransactionType.DEBIT && (
                                                            <Typography color="error"> {transaction?.amount?.toFixed(2)}</Typography>
                                                        )}{" "}
                                                    </StyledTableCell>

                                                    <StyledTableCell className="tableContentFont" align="left">
                                                        <Typography> {transaction?.balance?.toFixed(2)}</Typography>
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            </>
                                        ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    ) : (
                        <NoRecords />
                    )}
                    {state.totalTransactionsCount > 0 && (
                        <Grid
                            className="my-2"
                            style={{
                                zIndex: "2",
                                display: "flex",
                                justifyContent: "space-between",
                                padding: 10,
                            }}
                        >
                            <Grid
                                style={{
                                    marginTop: "15px",
                                }}
                            >
                                Total Transactions : {state.totalTransactionsCount}
                            </Grid>

                            <TablePaginationShowPage
                                rowsPerPageOptions={[5, 10, 25, 100]}
                                colSpan={3}
                                count={state.totalTransactionsCount}
                                rowsPerPage={pageSize}
                                page={currentPage}
                                slotProps={{
                                    select: {
                                        "aria-label": "Rows per page",
                                    },
                                    actions: {
                                        showFirstButton: true,
                                        showLastButton: true,
                                        slots: {
                                            firstPageIcon: FirstPageRoundedIcon,
                                            lastPageIcon: LastPageRoundedIcon,
                                            nextPageIcon: ChevronRightRoundedIcon,
                                            backPageIcon: ChevronLeftRoundedIcon,
                                        },
                                    },
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                            <AlertMessageComponent
                                message={errorResponse}
                                fieldName={"ErrorMessage"}
                                handleClose={() => setErrorResponse("")}
                                show={Boolean(errorResponse)}
                            />
                        </Grid>
                    )}
                </CardContent>
                {openFilter && (
                    <FilterTransactionModel
                        open={openFilter}
                        searchParams={searchParams}
                        handleCloseFilterModel={handleCloseFilterModel}
                        handleClickSearch={handleClickSearch}
                    />
                )}
            </Card>
            <AlertMessageComponent
                message={errorResponse}
                fieldName={"errorResponse"}
                handleClose={() => setErrorResponse("")}
                show={Boolean(errorResponse)}
            />
        </div>
    );
}
